import {ManifestCardPropsV2} from "../common/types/cards.type";
import {CardContainer, CardGrid, MicroCard} from "../common/styles/cards.style";
import {Elevation} from "@blueprintjs/core";
import {ManifestCardHeaderV2} from "../common/components/ManifestCardCommonV2";
import AssignmentLoadingWrapper from "../common/components/AssignmentLoadingWrapper";
import React, {useEffect} from "react";
import {createCardHandlers} from "../common/utils/cardHandlers";
import {scrollToElement} from "../common/utils/scrollToElement";

export const ManifestDriverMicroCard = React.memo(
  ({
    manifest,
    colors,
    isSelected,
    isHighlighted,
    disabled,
    cardConfigurations,
    onSelectedManifest,
    onDrillDownManifest,
    onLocationMarkerClick,
    isPending
  }: ManifestCardPropsV2) => {
    const {handleOnSelected, handleDrillDownManifest} = createCardHandlers({
      onSelectedManifest,
      onDrillDownManifest
    });

    useEffect(() => {
      if (isSelected) {
        scrollToElement(`manifest-micro-card-item-${manifest.manifestDriverId}`);
      }
    }, [isSelected, manifest.manifestDriverId]);
    return (
      <AssignmentLoadingWrapper isLoading={isPending}>
        <CardContainer
          id={`manifest-dnd-target-${manifest.manifestDriverId}`}
          data-manifestdriverid={manifest.manifestDriverId}
          data-cardtype={"card"}
        >
          <MicroCard
            id={`manifest-micro-card-item-${manifest.manifestDriverId}`}
            elevation={Elevation.ONE}
            isSelected={isSelected}
            isHighlighted={isHighlighted}
            disabled={disabled}
            data-testid={`manifest-micro-card-item-${manifest.manifestDriverId}`}
            onClick={(e: any) => {
              if (!disabled) {
                handleOnSelected(e, manifest);
              }
            }}
          >
            <CardGrid data-testid={"card-grid"} isSelected={isSelected} bodyHeight={0}>
              <ManifestCardHeaderV2
                manifest={manifest}
                handleDrillDownManifest={handleDrillDownManifest}
                onLocationMarkerClick={onLocationMarkerClick}
                stopsColor={colors ?? []}
                isSelected={isSelected}
                disabled={disabled}
                cardConfigurations={cardConfigurations}
              />
            </CardGrid>
          </MicroCard>
        </CardContainer>
      </AssignmentLoadingWrapper>
    );
  }
);
ManifestDriverMicroCard.displayName = "ManifestDriverMicroCard";
